<template>
  <div :class="$style.container">
    <div
      v-for="(tab, index) in tabs"
      :key="index"
      :class="{ [$style.hidden]: !tab.shouldShowTab }"
    >
      <ul :class="$style.header">
        <li>
          <a
            :class="[$style.headerText, {
              [$style.activeHeaderText]: isActiveSelection(index),
            }]"
            data-test-id="SystemsMainPanelTabs_tab"
            @click="handleClick(index)"
          >
            {{ tab.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SystemsMainPanelTabs',

  props: {
    activeSelection: {
      type: Number,
      default: 0,
    },
    badStateDevices: {
      type: Boolean,
      default: false,
    },
    unacknowledgedDevices: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tabs: [
        {
          label: 'All',
          shouldShowTab: true,
        },
        {
          label: 'Needs Attention',
          shouldShowTab: this.badStateDevices,
        },
        {
          label: 'User Enrolled Devices',
          shouldShowTab: this.unacknowledgedDevices,
        },
      ],
    };
  },

  methods: {
    async handleClick(index) {
      this.$emit('click', index);
    },

    isActiveSelection(index) {
      return this.activeSelection === index;
    },
  },
};
</script>

<style module>
@value (jcGrey800) from '~css/brand-colors.css';

.container {
  display: flex;
}

.header {
  font-size: 1.5rem;
  font-weight: 700;
  list-style: none;
  margin-top: 10px;
  padding: 0 0 0 20px;
}

.headerText {
  color: jcGrey800;
  cursor: pointer;
  text-decoration: none;
}

.hidden {
  display: none;
}

.activeHeaderText {
  border-bottom: 2px solid var(--jcPrimary);
}
</style>
